import type { UIFeatures } from '@models/Account'

/**
 * Whether a workspace feature is visible to the current viewer.
 *
 * The admin/user axis of the ui_features matrix is now resolved SERVER
 * SIDE and shipped on /my-account as `visible_features` (see
 * team.services.ui_features.resolve_visible_features). Previously every
 * surface — web nav, Teams nav, Teams dashboard, Dashboard overview,
 * Finance-Settings header — read the raw matrix, computed the viewer's
 * tier itself, and picked a column, so the five could disagree with each
 * other and with the backend. This is now a membership check.
 *
 * `undefined` means the account payload hasn't resolved (or predates the
 * field), NOT "hidden" — fail open, matching the matrix's own
 * absent-key-is-visible default. Never collapse that unknown into false:
 * this composes with the relevant RBAC permission at every call site (a
 * `*.view` on the nav, but `task.add` / `workflow.add` on the Dashboard's
 * create buttons), and RBAC still governs the endpoints, so showing a tab
 * briefly is strictly better than blanking someone's nav on a slow
 * response.
 */
export const isUIFeatureVisible = (key: keyof UIFeatures, visibleFeatures?: string[] | null): boolean => {
  if (!visibleFeatures) return true
  return visibleFeatures.includes(key)
}
